import { createAction } from '@reduxjs/toolkit';
import { DictionaryItem, DictionaryName, FiltersCacheShape } from './model';

// Размеченное объединение: ключ dict задаёт тип items, поэтому положить теги
// в кэш категорий не выйдет.
export type StoredPayload = {
  [N in DictionaryName]: { dict: N; key: string; items: DictionaryItem<N>[] };
}[DictionaryName];

export const stored = createAction<StoredPayload, 'al/filtersCache/stored'>(
  'al/filtersCache/stored',
);

export const hydrated = createAction<
  { cache: Partial<FiltersCacheShape> },
  'al/filtersCache/hydrated'
>('al/filtersCache/hydrated');
